export default __webpack_public_path__ + "static/media/about--tablet@2x.7e08a896.webp";